import { apiRequest } from './http';
import type { SaveServiceRequest, ServiceOption, ServiceSummary, ServiceTestResult } from './types';

const servicesPath = '/api/manage/services';

export async function listServices(): Promise<ServiceSummary[]> {
  const response = await apiRequest<{ items?: ServiceSummary[] }>(servicesPath);
  return response.items ?? [];
}

/** DT-12: author-visible service picker source, no admin-only detail. */
export async function listServiceOptions(): Promise<ServiceOption[]> {
  const response = await apiRequest<{ items?: ServiceOption[] }>('/api/manage/service-options');
  return response.items ?? [];
}

export async function saveService(request: SaveServiceRequest, serviceId?: string): Promise<ServiceSummary> {
  return apiRequest<ServiceSummary>(serviceId ? `${servicesPath}/${encodeURIComponent(serviceId)}` : servicesPath, {
    method: serviceId ? 'PUT' : 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request)
  });
}

export async function deleteService(serviceId: string): Promise<void> {
  await apiRequest<void>(`${servicesPath}/${encodeURIComponent(serviceId)}`, { method: 'DELETE' });
}

/** SV-05: runs the real executor, so a broken lookup is caught before it ships. */
export async function testService(serviceId: string, values: Record<string, string>): Promise<ServiceTestResult> {
  return apiRequest<ServiceTestResult>(`${servicesPath}/${encodeURIComponent(serviceId)}/test`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ values })
  });
}
